<template>
  <div>
    <el-row class="search_add2" :gutter="10">
      <el-col :span="4">
        <el-date-picker
          v-model="startTime"
          type="datetime"
          value-format="yyyy-MM-dd HH:mm:ss"
          format="yyyy/MM/dd HH:mm:ss"
          placeholder="选择日期"
        >
        </el-date-picker>
      </el-col>
      <el-col :span="4">
        <el-date-picker
          v-model="endTime"
          type="datetime"
          value-format="yyyy-MM-dd HH:mm:ss"
          format="yyyy/MM/dd HH:mm:ss"
          placeholder="选择日期"
        >
        </el-date-picker>
      </el-col>
      <el-col :span="4">
        <el-input placeholder="数据类型" v-model="dataType"></el-input>
      </el-col>
      <el-col :span="2">
        <el-button type="primary" icon="el-icon-search" @click="search"
          >搜索</el-button
        >
      </el-col>
    </el-row>

    <el-table
      :data="data"
      border
      stripe
      :height="tableHeight"
      style="width: 100%"
    >
      <af-table-column prop="device_id" label="设备编号"> </af-table-column>
      <af-table-column
        prop="time"
        :label="'time/采集时间'"
        :render-header="renderheader"
      >
        <template slot-scope="scope">
          {{ formatDate(scope.row.time) }}
        </template>
      </af-table-column>
      <af-table-column
        prop="data_type"
        :label="'data_type/数据类型'"
        :render-header="renderheader"
      >
      </af-table-column>
      <af-table-column
        prop="prto_prefix"
        :label="'prto_prefix/帧头'"
        :render-header="renderheader"
      >
      </af-table-column>
      <af-table-column
        prop="prto_type"
        :label="'prto_type/协议类型'"
        :render-header="renderheader"
      >
      </af-table-column>
      <af-table-column
        prop="ack"
        :label="'ack/下行应答状态'"
        :render-header="renderheader"
      >
      </af-table-column>
      <af-table-column
        prop="seq"
        :label="'seq/自增计数'"
        :render-header="renderheader"
      >
      </af-table-column>
      <af-table-column
        prop="rtc32k"
        :label="'rtc32k/RTC(Real Time Clock)'"
        :render-header="renderheader"
      >
      </af-table-column>
      <af-table-column prop="hardware_lat" label="硬件GPS经度">
      </af-table-column>
      <af-table-column prop="hardware_lng" label="硬件GPS纬度">
      </af-table-column>
      <af-table-column prop="gd_lat" label="高德火星坐标系经度">
      </af-table-column>
      <af-table-column prop="gd_lng" label="高德火星坐标系纬度">
      </af-table-column>
      <af-table-column prop="hardware_addr" label="GPS经纬度地址">
      </af-table-column>
      <af-table-column
        prop="cells"
        :label="'cells/GPRS基站列表'"
        :render-header="renderheader"
      >
        <template slot-scope="scope">
          {{ JSON.stringify(scope.row.cells) }}
        </template>
      </af-table-column>
      <af-table-column
        prop="cells_csq"
        :label="'cells_csq/信号强度'"
        :render-header="renderheader"
      >
      </af-table-column>
      <af-table-column prop="basestation_lat" label="基站经度">
      </af-table-column>
      <af-table-column prop="basestation_lng" label="基站纬度">
      </af-table-column>
      <af-table-column prop="basestation_addr" label="基站地址">
      </af-table-column>
      <af-table-column
        prop="wifis"
        :label="'wifis/Wifi Mac列表'"
        :render-header="renderheader"
      >
        <template slot-scope="scope">
          {{ JSON.stringify(scope.row.wifis) }}
        </template>
      </af-table-column>
      <af-table-column
        prop="voltage"
        :label="'voltage/电压数据'"
        :render-header="renderheader"
      >
      </af-table-column>
      <af-table-column
        prop="empty"
        :label="'empty/空满数据'"
        :render-header="renderheader"
      >
      </af-table-column>
      <af-table-column
        prop="gsensor"
        :label="'gsensor/G-Sensor加速度数据'"
        :render-header="renderheader"
      >
        <template slot-scope="scope">
          {{ JSON.stringify(scope.row.gsensor) }}
        </template>
      </af-table-column>
    </el-table>
    <div class="tableDel-Page">
      <Pagination :params="pagin" @pageBind="getList"></Pagination>
    </div>
  </div>
</template>

<script>
import Pagination from "@/components/Pagination";
import moment from "moment";
export default {
  data() {
    return {
      data: [],
      pagin: {
        pageNum: 1,
        pageSize: 20,
        total: 0,
      },
      env: this.getEnv(),
      id: 0,
      startTime: "",
      endTime: "",
      dataType: "",
      tableHeight: "550px",
    };
  },
  async created() {
    if (this.$route.params.id) {
      this.id = this.$route.params.id;
      this.tableHeight = document.documentElement.clientHeight - 200 + "px";
    } else {
      this.$router.go(-1);
    }
  },
  methods: {
    formatDate(value) {
      return moment.unix(value).format("YYYY-MM-DD HH:mm:ss");
    },
    search() {
      //搜索
      this.pagin.pageNum = 1;
      this.getList();
    },
    getList() {
      let params = {
        deviceId: this.id,
        pageNum: this.pagin.pageNum,
        pageSize: this.pagin.pageSize,
      };
      if (this.startTime != "") {
        params.startTime = this.startTime;
      }
      if (this.endTime != "") {
        params.endTime = this.endTime;
      }
      if (this.dataType != "") {
        params.dataType = this.dataType;
      }
      this.$http
        .post(`${this.env}/manage/device-mqtt-uplink-his/list`, params)
        .then((results) => {
          this.data = results["data"]["data"]["records"];
          this.pagin.total = results["data"]["data"]["total"];
        });
    },
    getEnv() {
      if (location.host == "localhost:8080") {
        return "https://dev.iotmanage.baitengfa.com";
      } else if (location.host == "dev.iotmanage.baitengfa.com") {
        return "https://dev.iotmanage.baitengfa.com";
      } else if (location.host == "iotmanage.baitengfa.com") {
        return "https://iotmanage.baitengfa.com";
      }
    },
    block() {
      this.$router.push("/setting/admin");
    },
    renderheader(h, { column }) {
      return h("span", {}, [
        h("span", {}, column.label.split("/")[0]),
        h("br"),
        h("span", {}, column.label.split("/")[1]),
      ]);
    },
  },
  components: {
    Pagination,
  },
};
</script>